<h1 class="auth-title">Crea una nueva contraseña</h1>
<p class="auth-lead">La usarás para entrar a partir de ahora. El enlace del correo vence a los 60 minutos.</p>

@if (isTokenMissing) {
<div class="notice" role="alert">
  <p>Este enlace ya no sirve. Pide uno nuevo para cambiar tu contraseña.</p>
  <a routerLink="/auth/forgot-password" class="link">Pedir un enlace nuevo</a>
</div>
}

<form class="form-start" [formGroup]="resetForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="fields">
    <div>
      <label class="field-label" for="reset-password">Nueva contraseña</label>
      <input type="password" id="reset-password" class="input" formControlName="password" autocomplete="new-password"
        minlength="8"
        [class.is-invalid]="passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)"
        [attr.aria-invalid]="passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)"
        aria-describedby="reset-password-hint" />
      @if (passwordControl.invalid && (passwordControl.dirty || passwordControl.touched)) {
      <p class="field-error" id="reset-password-hint">Usa al menos 8 caracteres.</p>
      } @else {
      <p class="field-hint" id="reset-password-hint">
        Al menos 8 caracteres, con una mayúscula, una minúscula, un número y un símbolo.
      </p>
      }
    </div>

    <div>
      <label class="field-label" for="reset-confirm">Repite la contraseña</label>
      <input type="password" id="reset-confirm" class="input" formControlName="confirmPassword"
        autocomplete="new-password"
        [class.is-invalid]="resetForm.errors?.['passwordMismatch'] && (confirmPasswordControl.dirty || confirmPasswordControl.touched)"
        [attr.aria-invalid]="resetForm.errors?.['passwordMismatch'] && (confirmPasswordControl.dirty || confirmPasswordControl.touched)"
        [attr.aria-describedby]="resetForm.errors?.['passwordMismatch'] && (confirmPasswordControl.dirty || confirmPasswordControl.touched) ? 'reset-confirm-error' : null" />
      @if (resetForm.errors?.['passwordMismatch'] && (confirmPasswordControl.dirty || confirmPasswordControl.touched)) {
      <p class="field-error" id="reset-confirm-error">Las dos contraseñas deben ser iguales.</p>
      }
    </div>
  </div>

  <div class="actions">
    <button type="submit" class="btn-primary" [disabled]="isSubmitting || resetForm.invalid || isTokenMissing">
      @if (isSubmitting) {
      <span class="spinner" aria-hidden="true"></span>
      Guardando…
      } @else {
      Guardar contraseña
      }
    </button>
  </div>
</form>

<p class="switch-line">
  ¿Ya la recordaste?
  <a routerLink="/auth/signin" class="link">Vuelve a iniciar sesión</a>
</p>
